// extracted by mini-css-extract-plugin
export default {"bgImage":"footer_bgImage__AIz7-"};